module.exports = __webpack_public_path__ + "static/media/about-icon.bf48010c.png";